

























import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';

export default Vue.extend({
  name: 'GColorForm',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    itemComment: { type: Array as PropType<string[]>, default: () => [] },
    value: { type: String as PropType<string>, default: '' },
    name: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string>, required: true },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gColorFormProvider as any).validate();
    },
  },
});
